var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, Children, } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Glide, { Swipe, Images, Anchors, Controls, Autoplay, Keyboard, } from '@glidejs/glide/dist/glide.modular.esm';
import inRange from 'lodash/inRange';
import GetElementWidth from './GetElementWidth';
var GlideWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n"])));
var GlideTrack = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: ", ";\n"], ["\n  overflow: ", ";\n"])), function (_a) {
    var frameOverflow = _a.frameOverflow;
    return frameOverflow || 'hidden';
});
var GlideSlides = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: ", ";\n  position: relative;\n  width: 100%;\n  list-style: none;\n  backface-visibility: hidden;\n  transform-style: preserve-3d;\n  touch-action: pan-Y;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  flex-wrap: nowrap;\n  will-change: transform;\n"], ["\n  overflow: ", ";\n  position: relative;\n  width: 100%;\n  list-style: none;\n  backface-visibility: hidden;\n  transform-style: preserve-3d;\n  touch-action: pan-Y;\n  padding: 0;\n  white-space: nowrap;\n  display: flex;\n  flex-wrap: nowrap;\n  will-change: transform;\n"])), function (_a) {
    var sliderOverflow = _a.sliderOverflow;
    return sliderOverflow || 'hidden';
});
var GlideSlide = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  flex-shrink: 0;\n  white-space: normal;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n"], ["\n  width: 100%;\n  height: 100%;\n  flex-shrink: 0;\n  white-space: normal;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n"])));
var GlideArrowLeft = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n"])));
var GlideArrowRight = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n"])));
var GlideBottomControls = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n"])));
var GlideCarousel = /** @class */ (function (_super) {
    __extends(GlideCarousel, _super);
    function GlideCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.carouselId = GlideCarousel.lastUsedId++;
        _this.glide = null;
        _this.state = {
            containerWidth: props.initialContainerWidth,
            cloneSlideWidth: 0,
        };
        _this.carouselId = GlideCarousel.lastUsedId++;
        _this.setContainerWidth = _this.setContainerWidth.bind(_this);
        _this.nextSlide = _this.nextSlide.bind(_this);
        _this.previousSlide = _this.previousSlide.bind(_this);
        _this.goToSlide = _this.goToSlide.bind(_this);
        return _this;
    }
    GlideCarousel.prototype.getGlideSettings = function () {
        var containerWidth = this.state.containerWidth;
        var _a = this.props, autoplay = _a.autoplay, autoplayInterval = _a.autoplayInterval, cellSpacing = _a.cellSpacing, fixedSlideWidth = _a.fixedSlideWidth, pauseOnHover = _a.pauseOnHover, scrollToTheLastSlide = _a.scrollToTheLastSlide, slideWidth = _a.slideWidth, slidesToShow = _a.slidesToShow, startAt = _a.startAt, keyboard = _a.keyboard, wrapAround = _a.wrapAround, swipeThreshold = _a.swipeThreshold, children = _a.children;
        var perView = slidesToShow;
        // TODO: refactor slideWidth logic pls
        var peekAfter = containerWidth !== null ? containerWidth * (1 - slideWidth) : 0;
        if (fixedSlideWidth) {
            var containerWidthWithGap = containerWidth + cellSpacing;
            var slideWidthWithGap = fixedSlideWidth + cellSpacing;
            var slidesCount = React.Children.count(children);
            perView = Math.min(Math.floor(containerWidthWithGap / slideWidthWithGap), slidesCount);
            peekAfter = containerWidthWithGap - perView * slideWidthWithGap;
        }
        return {
            swipeThreshold: swipeThreshold ? swipeThreshold : fixedSlideWidth || 80,
            dragThreshold: fixedSlideWidth || 80,
            type: wrapAround ? 'carousel' : 'slider',
            rewind: !!wrapAround,
            bound: !scrollToTheLastSlide,
            perView: perView,
            gap: cellSpacing,
            autoplay: autoplay ? autoplayInterval : false,
            hoverpause: pauseOnHover,
            peek: {
                after: peekAfter,
                before: 0,
            },
            startAt: startAt,
            keyboard: keyboard,
        };
    };
    GlideCarousel.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.disabled) {
            return;
        }
        var settings = this.getGlideSettings();
        var slidesCount = Children.toArray(this.props.children).length;
        this.glide = new Glide("#glide-" + this.carouselId, settings)
            .on('run.before', function (_a) {
            var direction = _a.direction;
            var perView = settings.perView;
            var index = _this.glide.index;
            if (_this.props.beforeSlide) {
                _this.props.beforeSlide();
            }
            if (inRange(perView, 2, 4)) {
                if (direction === '>') {
                    if (index + 1 < slidesCount) {
                        var nextIndex = index + 1;
                        _this.glide.index = nextIndex;
                    }
                }
                else {
                    var prevIndex = index - 1;
                    _this.glide.index = prevIndex;
                }
            }
        })
            .on('run.after', function () {
            if (_this.props.afterSlide) {
                _this.props.afterSlide(_this.glide.index);
            }
        });
        this.glide.mount({
            Swipe: Swipe,
            Images: Images,
            Anchors: Anchors,
            Controls: Controls,
            Autoplay: Autoplay,
            Keyboard: Keyboard,
            // override default Clones extension because clones aren't aware of
            // changes in react components in runtime. Clones are created using
            // react, but glide still use this extension to calculate width of all
            // clones
            Clones: function (_, Components, EventBus) {
                // during these events slideWidth can change, we add listener here
                // because of access to instances of Sizes Glide extension
                EventBus.on(['update', 'build.before'], function () {
                    if (_this.glide.isType('carousel')) {
                        _this.setState({
                            cloneSlideWidth: Components.Sizes.slideWidth,
                        });
                    }
                });
                return Object.defineProperty({}, 'grow', {
                    /* Gets additional dimensions value caused by clones.*/
                    get: function () {
                        return (Components.Sizes.slideWidth + Components.Gaps.value) *
                            _this.getCloneCount() *
                            2;
                    },
                });
            },
        });
    };
    GlideCarousel.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this, props = _a.props, state = _a.state;
        if (props.disabled) {
            return;
        }
        if (props.wrapAround !== prevProps.wrapAround ||
            props.swipeThreshold !== prevProps.swipeThreshold ||
            props.scrollToTheLastSlide !== prevProps.scrollToTheLastSlide ||
            props.slidesToShow !== prevProps.slidesToShow ||
            props.cellSpacing !== prevProps.cellSpacing ||
            props.autoplay !== prevProps.autoplay ||
            props.autoplayInterval !== prevProps.autoplayInterval ||
            props.pauseOnHover !== prevProps.pauseOnHover ||
            props.slideWidth !== prevProps.slideWidth ||
            props.fixedSlideWidth !== prevProps.fixedSlideWidth ||
            props.startAt !== prevProps.startAt ||
            props.keyboard !== prevProps.keyboard ||
            React.Children.count(props.children) !==
                React.Children.count(props.children) ||
            state.containerWidth !== prevState.containerWidth) {
            var newSettings = this.getGlideSettings();
            this.glide.update(newSettings);
        }
    };
    GlideCarousel.prototype.componentWillUnmount = function () {
        if (this.glide) {
            this.glide.destroy();
        }
    };
    GlideCarousel.prototype.setContainerWidth = function (width) {
        this.setState({ containerWidth: width });
    };
    GlideCarousel.prototype.previousSlide = function () {
        if (this.glide) {
            var slidesToScroll = this.props.slidesToScroll || this.props.slidesToShow;
            this.glide.go("<" + slidesToScroll);
        }
    };
    GlideCarousel.prototype.nextSlide = function () {
        if (this.glide) {
            var slidesToScroll = this.props.slidesToScroll || this.props.slidesToShow;
            // for unknown reason glide requires negative number
            // when going right n slides
            this.glide.go(">" + -slidesToScroll);
        }
    };
    GlideCarousel.prototype.goToSlide = function (newIndex) {
        if (this.glide) {
            this.glide.go("=" + newIndex);
        }
    };
    GlideCarousel.prototype.getCloneCount = function () {
        var _a = this.props, slidesToShow = _a.slidesToShow, slideWidth = _a.slideWidth, wrapAround = _a.wrapAround;
        if (!wrapAround) {
            return null;
        }
        var peekIncrementer = slideWidth !== null && slideWidth !== 1 ? 1 : 0;
        return slidesToShow + peekIncrementer + Math.round(slidesToShow / 2);
    };
    GlideCarousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, slideWidth = _a.slideWidth, slidesToShow = _a.slidesToShow, slidesToScroll = _a.slidesToScroll, fixedSlideWidth = _a.fixedSlideWidth, scrollToTheLastSlide = _a.scrollToTheLastSlide, frameOverflow = _a.frameOverflow, sliderOverflow = _a.sliderOverflow, renderCenterLeftControls = _a.renderCenterLeftControls, renderCenterRightControls = _a.renderCenterRightControls, renderBottomCenterControls = _a.renderBottomCenterControls, children = _a.children;
        var cloneSlideWidth = this.state.cloneSlideWidth;
        var childrenArray = Children.toArray(children);
        var slideCount = childrenArray.length;
        var cloneCount = this.getCloneCount();
        var appendClones = childrenArray.slice(0, cloneCount);
        var prependClones = childrenArray.slice(slideCount - cloneCount);
        return (React.createElement(GlideWrapper, { id: "glide-" + this.carouselId, className: "glide" },
            React.createElement(GetElementWidth, { onWidthChange: this.setContainerWidth, disabled: (slideWidth === null || slideWidth === 1) && !fixedSlideWidth },
                React.createElement(GlideTrack, { className: "glide__track", "data-glide-el": "track", frameOverflow: frameOverflow },
                    React.createElement(GlideSlides, { className: "glide__slides", sliderOverflow: sliderOverflow },
                        prependClones.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide glide__slide--clone", key: "prepend-clone-" + i, style: { width: cloneSlideWidth } }, child)); }),
                        childrenArray.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide", key: i }, child)); }),
                        appendClones.map(function (child, i) { return (React.createElement(GlideSlide, { className: "glide__slide glide__slide--clone", key: "append-clone-" + i, style: { width: cloneSlideWidth } }, child)); })))),
            React.createElement(GlideCurrentSlide, { glide: this.glide }, function (currentSlide) { return (React.createElement(React.Fragment, null,
                renderCenterLeftControls ? (React.createElement(GlideArrowLeft, null, renderCenterLeftControls({
                    previousSlide: _this.previousSlide,
                    currentSlide: currentSlide,
                    slideCount: slideCount,
                }))) : null,
                renderCenterRightControls ? (React.createElement(GlideArrowRight, null, renderCenterRightControls({
                    nextSlide: _this.nextSlide,
                    currentSlide: currentSlide,
                    slideCount: slideCount,
                    slidesToShow: slidesToScroll || slidesToShow,
                    canScrollToTheLastSlide: scrollToTheLastSlide,
                }))) : null,
                renderBottomCenterControls ? (React.createElement(GlideBottomControls, null, renderBottomCenterControls({
                    currentSlide: currentSlide,
                    slideCount: slideCount,
                    goToSlide: _this.goToSlide,
                }))) : null)); })));
    };
    GlideCarousel.propTypes = {
        /** Initial measured width of carousel container */
        initialContainerWidth: PropTypes.number,
        /** Center left carousel controls (prev slide button) */
        renderCenterLeftControls: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.oneOf([false]),
        ]),
        /** Center right carousel controls (next slide button) */
        renderCenterRightControls: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.oneOf([false]),
        ]),
        /** Bottom center carousel controls (go to specific slide) */
        renderBottomCenterControls: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.oneOf([false]),
        ]),
        /** Event callback called before the slide is changed */
        beforeSlide: PropTypes.func,
        /** Event callback called after the slide is changed */
        afterSlide: PropTypes.func,
        /** Slide components */
        children: PropTypes.node,
        /** Fallback ref key (default: 'ref') */
        fallbackRefKey: PropTypes.string,
        /** Sets overflow style property on slider frame */
        frameOverflow: PropTypes.string,
        /** Sets overflow style property on slider container */
        sliderOverflow: PropTypes.string,
        /** Number of slides to show at once */
        slidesToShow: PropTypes.number,
        /** Number of slides to scroll at once (defaults to slidesToShow) */
        slidesToScroll: PropTypes.number,
        /**
         * Needed to set proper peek value (last slide which is partially visible)
         * Accepts perentage value and is calcuated:
         * slideWidthInPixels = containerWidth / slidesToShow * (1 - props.slideWidth)
         */
        slideWidth: PropTypes.number,
        /**
         * For slidesToShow > 1 carousel by default can be scrolled to the max of:
         * slides length - slidesToShow
         * with this option it can be scrolled to the very last slide
         */
        scrollToTheLastSlide: PropTypes.bool,
        /** spacing for each slide */
        cellSpacing: PropTypes.number,
        /** Sets infinite wrapAround mode */
        wrapAround: PropTypes.bool,
        /** Minimal swipe distance needed to change the slide. */
        swipeThreshold: PropTypes.number,
        /** Autoplay mode active */
        autoplay: PropTypes.bool,
        /** Interval for autoplay iteration */
        autoplayInterval: PropTypes.number,
        /** Pause autoPlay when mouse is over carousel */
        pauseOnHover: PropTypes.bool,
        /** A-B tests disables slider events */
        disabled: PropTypes.bool,
        fixedSlideWidth: PropTypes.number,
        /** start at specific slide number defined with zero-based index */
        startAt: PropTypes.number,
        /** Allows for controlling movement of the instance with keyboard's arrow keys */
        keyboard: PropTypes.bool,
    };
    GlideCarousel.defaultProps = {
        slidesToShow: 1,
        perTouch: 1,
        cellSpacing: 0,
        autoplay: false,
        autoplayInterval: 3000,
        pauseOnHover: false,
        slideWidth: null,
        scrollToTheLastSlide: false,
        disabled: false,
        startAt: 0,
        keyboard: false,
    };
    GlideCarousel.lastUsedId = 0;
    return GlideCarousel;
}(React.Component));
export { GlideCarousel };
function GlideCurrentSlide(props) {
    var _a = __read(useState(0), 2), currentSlide = _a[0], setCurrentSlide = _a[1];
    useEffect(function () {
        if (props.glide) {
            // glide event listeners cannot be unsubscribed.
            // This one is thankfully applied only once and it will be
            // cleared when glide instance is destroyed nonetheless
            props.glide.on('run', function () {
                setCurrentSlide(props.glide.index);
            });
        }
    }, [props.glide]);
    return props.children(currentSlide);
}
export default GlideCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
